import { Label } from '@kcftech/design-system';
import { ValidatableLabel } from 'components/forms/ValidatableLabel';
import { useFormContext, useFormState } from 'react-hook-form';
import { AlarmThresholdFormFields } from './shared';
import { SecondaryText, StyledCard, StyledNumberInput } from './styled';
import { criticalAlarmRules, warningFieldRules } from './validation';

export function AlarmCard() {
    const { register, control } = useFormContext<AlarmThresholdFormFields>();
    const { errors } = useFormState({ control });

    return (
        <StyledCard className="flex-column gap-10">
            <Label label="PERCENTAGE OF ALARM LEVEL" />
            <div className="flex-row gap-20 mr-10">
                <ValidatableLabel label="Warning" error={errors.warning} required>
                    <div className="flex-row align-center gap-5">
                        <StyledNumberInput
                            {...register('warning', warningFieldRules)}
                            invalid={Boolean(errors.warning)}
                        />
                        <SecondaryText>%</SecondaryText>
                    </div>
                </ValidatableLabel>
                <ValidatableLabel
                    label="Critical Alarm"
                    error={errors.criticalAlarm}
                    required
                >
                    <div className="flex-row align-center gap-5">
                        <StyledNumberInput
                            {...register('criticalAlarm', criticalAlarmRules)}
                            invalid={Boolean(errors.criticalAlarm)}
                        />
                        <SecondaryText>%</SecondaryText>
                    </div>
                </ValidatableLabel>
            </div>
        </StyledCard>
    );
}
